import styled from 'styled-components';
import { ButtonReg } from 'atoms/Buttons';

export const SidebarContainer = styled.div`
  padding: 20px 24px;
  border-right: 1px solid #E0E0E0;
  position: relative;
  height: 100%;
  overflow-y: auto;
`

export const HeaderContainer = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.mocaLtGrey};
  margin-bottom: 12.5px;
`

export const CloseBtnContainer = styled.div`
  /* position: absolute; */
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  /* bottom: 0; */
  left: 0;
  padding: 32px 0;

  @media (max-width: 1366px) {
    flex-direction: column;
    align-items: center;
  }
`

export const CloseBtn = styled(ButtonReg)`
  @media (max-width: 1366px) {
    margin-bottom: 5px;
  }
`
